import React from "react";
import { Box, Typography, Divider, useTheme } from "@mui/material";
import Header from "../../../components/Header";
import { useNavigate, useParams } from "react-router-dom";
import ErrorComponent from "../../../components/ErrorComponent";
import LoadingComponent from "../../../components/LoadingComponent";
import { tokens } from "../../../theme";
import SuccessButton from "../../../components/SuccessButton";
import { useGetUsageByIdQuery } from "../../../services/inventoryService";
import ProductsList from "../../../components/ProductsList";
import { formatDate } from "../../../utils/formatDate";
import { getUsageTypeByValue } from "../../../constants/enums";

const ViewUsage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: usage, isLoading, error } = useGetUsageByIdQuery(id);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  if (isLoading) return <LoadingComponent />;
  if (error) return <ErrorComponent />;

  return (
    <Box m="20px">
      <Header title="Detalles de la Salida" />

      <Box
        display="grid"
        gap="20px"
        gridTemplateColumns="repeat(5, minmax(0, 1fr))"
      >

        {/* Type Quantity */}
        <Box>
            <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Tipo
            </Typography>
            <Typography variant="body1" color={colors.grey[100]}>
            {getUsageTypeByValue(usage?.type).label}
            </Typography>
        </Box>

        {/* Date */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Fecha
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {formatDate(usage?.used_at)}
          </Typography>
        </Box>

        {/* Products Quantity */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Productos Usados
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {usage?.usage_count}
          </Typography>
        </Box>

        {/* Total Cost */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Costo Total
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {`$${usage?.total_usage_cost}`}
          </Typography>
        </Box>

        {/* Application Name */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Aplicación
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {usage?.application_name ? usage?.application_name : 'N/A' }
          </Typography>
        </Box>

        {/* Details Quantity */}
        <Box sx={{ gridColumn: "span 5" }}>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Detalle
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {usage?.detail ? usage?.detail : 'N/A' }
          </Typography>
        </Box>
      </Box>

      {/* Divider */}
      <Divider sx={{ my: "20px", borderColor: colors.grey[700] }} />

      {/* Products List Section */}
      <Typography variant="h5" fontWeight="bold" mb="16px" color={colors.grey[100]}>
        Productos
      </Typography>
      <ProductsList productsList={usage?.products} isReadOnly />
      <Box
        display="flex"
        justifyContent="end"
        gap="4px"
      >
        <SuccessButton label="Ver Compras" onClick={() => navigate('/usages')}/>
      </Box>
    </Box>
  );
};

export default ViewUsage;